// Get the user's TrustArc GDPR consent
import _ from 'lodash';
import { isBrowser } from './helper';
import { getCookie } from './getCookie';

// return an array containing values 0 - 3. these value represent:
// 0: the user has not asserted any consent, and has implied consent only for required cookies.
// 1: the user has asserted consent to required cookies.
// 2: the user has asserted consent to functional cookies.
// 3: the user has asserted consent to advertising cookies.
export const getTrustArcConsent = () => {
  if (!isBrowser) {
    return [0];
  }

  if (!_.get(window, 'PrivacyManagerAPI.callApi')) {
    const trustArcCookie = getCookie('notice_gdpr_prefs');
    return trustArcCookie
      ? trustArcCookie
          .replace(':', '')
          .split('|')
          .map((n) => n * 1 + 1)
      : [0];
  }

  const trustArcGDPRConsent = window.PrivacyManagerAPI.callApi('getGDPRConsentDecision', 'piaggiofastforward.com');
  return trustArcGDPRConsent.consentDecision;
};
